import React from "react";
import { Drawer, Table } from "antd";

const StockCheckDrawer = ({
  open,
  visible,
  onClose,
  stockData,
  precision,
  notFoundImg,
}) => {
  const isOpen = open ?? visible;
  const insufficientItems = stockData?.filter(
    (item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty
  ) || [];

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      closable={false}
      height="80vh"
      mask={true}
      styles={{ mask: { background: "#000000a6" } }}
      maskClosable="false"
      style={{
        textAlign: "center",
      }}
      styles={{ body: {
        padding: "5px 30px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      } }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "500",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: 0,
          fontSize: "1vw",
        }}
      >
        <img src={notFoundImg} alt="Stock Unavailable" style={{ width: "60px", height: "50px", marginTop: "5px" }} />
        <p style={{ margin: "2px 0", fontSize: "1.8em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
        <p
          style={{
            color: "#6c757d",
            fontWeight: 400,
            fontSize: "1.1em",
          }}
        >
          {`The following ${insufficientItems.length} items are not available in sufficient stock`}
        </p>
      </div>
      <Table
        className="sm-stock-check-table"
        pagination={false}
        style={{ height: "50vh" }}
        scroll={{ y: "43vh" }}
        columns={[
          {
            title: "Item Name",
            dataIndex: "name",
            key: "name",
            width: "30%",
            render: (text, record) => (
              <div>
                <div style={{ fontWeight: 500 }}>{text}</div>
                <div style={{ fontSize: "12px", color: "#888" }}>{record.productId}</div>
              </div>
            ),
          },
          { title: "Required", dataIndex: "orderQty", key: "orderQty", width: "25%" },
          { title: "Available", dataIndex: "availableQty", key: "availableQty", width: "25%" },
          {
            title: "Shortfall",
            key: "shortfall",
            width: "25%",
            render: (_, record) => {
              const diff = record.orderQty - record.availableQty;
              return (-Math.abs(diff)).toFixed(precision);
            },
          },
        ]}
        dataSource={insufficientItems}
        rowKey="productId"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "2vh",
          paddingRight: "1px",
        }}
      >
        <button
          style={{
            width: "25%",
            padding: "6px 12px",
            backgroundColor: "#2F3856",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </Drawer>
  );
};

export default StockCheckDrawer;
